export const PROMO_CODES = {
  idia: true,
  iknowcalvin: true,
  idiahodler: true,
  bullish: true,
  galaxy: true,
  givemecode: true,
}
